<template>
    <div>
      
        <h2 class="headline-s form-headline-dealer-app">Shipping Information</h2>
        <div class="notification-bar-wrapper-no-bg">
            <div class="drop-ship-banner">
                <span class="drop-ship-leftside">
                    <p class="title-s banner-title">
                        Shipping Location
                    </p>
                    <span class="cta-wrapper">
                        <button
                            id="shipping-info-same-as-mailing" 
                            type="button" 
                            :class="`${ sameAsMailingAddress ? 'small' : 'secondary small'} shipping-button-dealer-app${sameAsMailingAddress ? '-selected' : ''}`"
                            @click="setSameAsMailingAddress(true)">
                                Same As Mailing
                        </button>
                        <button
                            id="shipping-info-add-new" 
                            type="button" 
                            :class="`${ !sameAsMailingAddress ? 'small' : 'secondary small'} shipping-button-dealer-app${!sameAsMailingAddress ? '-selected' : ''}`"
                            @click="setSameAsMailingAddress(false)">
                                Add New
                        </button>
                    </span>
                </span>
            </div>
        </div>
        <div v-if="!sameAsMailingAddress">
            <div class="field-type-dealer-app-full-width">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            id="shipping_in_care_of" v-model="shipping_in_care_of"
                            :class="{'invalid-state-input': errors.shipping_in_care_of != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_in_care_of" :class="{'invalid-state': errors.shipping_in_care_of}">
                            <p>In Care Of *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_in_care_of">{{ errors.shipping_in_care_of }}</p></div>
                </div>
            </div>
            <div class="field-type-dealer-app">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            id="shipping_address1" v-model="shipping_address1"
                            :class="{'invalid-state-input': errors.shipping_address1 != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_address1" :class="{'invalid-state': errors.shipping_address1}">
                            <p>Street 1 *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_address1">{{ errors.shipping_address1 }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            id="shipping_address2" v-model="shipping_address2"
                            :class="{'invalid-state-input': errors.shipping_address2 != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_address2" :class="{'invalid-state': errors.shipping_address2}">
                            <p>Street 2</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_address2">{{ errors.shipping_address2 }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="shipping_city" v-model="shipping_city"
                            :class="{'invalid-state-input': errors.shipping_city != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_city" :class="{'invalid-state': errors.shipping_city}">
                            <p>City {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_city">{{ errors.shipping_city }}</p></div>
                </div>
                <div v-if="availableStates" class="field-state-dealer-app">
                    <custom-select
                        :aria-required="requireStateCity"
                        v-model="selectedState"
                        :label="`State/Province ${requireStateCity ? '*' : ''}`"
                        name="shipping_state" 
                        id="shipping_state" 
                        aria-label="Enter State/Province" 
                        :options="formattedStates"
                        :error="errors.shipping_state != null"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_state">{{ errors.shipping_state }}</p></div>
                </div>
                <div v-if="!availableStates" class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="shipping_state" v-model="shipping_state"
                            :class="{'invalid-state-input': errors.shipping_state != null}"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_state" :class="{'invalid-state': errors.shipping_state}">
                            <p>State {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_state">{{ errors.shipping_state }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCity"
                            id="shipping_zip_code" v-model="shipping_zip_code"
                            :class="{
                                'invalid-state-input': errors.shipping_zip_code != null
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label for="shipping_zip_code" :class="{'invalid-state': errors.shipping_zip_code}">
                            <p>Zip/Postal Code {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_zip_code">{{ errors.shipping_zip_code }}</p></div>
                </div>
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        v-model="selectedCountry"
                        label="Country *"
                        name="shipping_country" 
                        id="shipping_country" 
                        aria-label="Enter Shipping Country"
                        :options="formattedCountries"
                        :error="errors.shipping_country != null"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_country">{{ errors.shipping_country }}</p></div>
                </div>
            </div>
            <AddressValidationMessage
                class="field-state-dealer-app"
                :street1="shipping_address1"
                :street2="shipping_address2"
                :city="shipping_city"
                :state="shipping_state"
                :postal_code="shipping_zip_code"
                :country="shipping_country"
                @useSuggestedAddress="useSuggestedShippingAddress"
            />
        </div>
        <div v-for="(additional_shipping, index) in additional_shippings" :key="index" :id="`additional-shipping-address-${index}`">
            <div class="form-headline-dealer-app flex-row justify-center justify-between align-center">
                <h3 class="headline-xs">Additional Shipping {{ index+1 }}</h3>
                <CloseIcon class="mobile-hidden" style="cursor: pointer;" @click="removeShipping(index)" />
            </div>
            <div class="field-type-dealer-app-full-width">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            :id="`shipping_in_care_of_name_${index}`" v-model="additional_shipping.in_care_of"
                            :class="{
                                'invalid-state-input': errorsShippingInCareOfNamesExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_in_care_of_name_${index}`" :class="{'invalid-state': errorsShippingInCareOfNamesExists(index)}">
                            <p>In Care Of *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingInCareOfNamesExists(index)">{{ errors[`additional_shippings[${index}].in_care_of`] }}</p></div>
                </div>
            </div>
            <div class="field-type-dealer-app">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="true"
                            :id="`shipping_street_1_${index}`" v-model="additional_shipping.address1"
                            :class="{
                                'invalid-state-input': errorsShippingStreets1Exists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_street_1_${index}`" :class="{'invalid-state': errorsShippingStreets1Exists(index)}">
                            <p>Street 1 *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingStreets1Exists(index)">{{ errors[`additional_shippings[${index}].address1`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :id="`shipping_street_2_${index}`" v-model="additional_shipping.address2"
                            :class="{
                                'invalid-state-input': errorsShippingStreets2Exists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_street_2_${index}`" :class="{'invalid-state': errorsShippingStreets2Exists(index)}">
                            <p>Street 2</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingStreets2Exists(index)">{{ errors[`additional_shippings[${index}].address2`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCityFromCountry(additional_shipping.country_obj?.key)"
                            :id="`shipping_city_${index}`" v-model="additional_shipping.city"
                            :class="{
                                'invalid-state-input': errorsShippingCitiesExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_city_${index}`" :class="{'invalid-state': errorsShippingCitiesExists(index)}">
                            <p>City {{ requireStateCityFromCountry(additional_shipping.country_obj?.key) ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingCitiesExists(index)">{{ errors[`additional_shippings[${index}].city`] }}</p></div>
                </div>
                <div v-if="getAvailableStates(index)" class="field-state-dealer-app">
                    <custom-select
                        :aria-required="requireStateCityFromCountry(additional_shipping.country_obj?.key)"
                        v-model="additional_shipping.state_obj"
                        :label="`State/Province ${requireStateCityFromCountry(additional_shipping.country_obj?.key) ? '*' : ''}`"
                        :name="`shipping_state_${index}`" 
                        :id="`shipping_state_${index}`" 
                        aria-label="Enter State/Province"
                        :options="getAvailableStates(index)"
                        :error="errorsShippingStatesExists(index)"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingStatesExists(index)">{{ errors[`additional_shippings[${index}].state`] }}</p></div>
                </div>
                <div v-if="!getAvailableStates(index)" class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCityFromCountry(additional_shipping.country_obj?.key)"
                            :id="`shipping_state_${index}`" v-model="additional_shipping.state"
                            :class="{'invalid-state-input': errorsShippingStatesExists(index)}"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_state_${index}`" :class="{'invalid-state': errorsShippingStatesExists(index)}">
                            <p>State {{ requireStateCityFromCountry(additional_shipping.country_obj?.key)? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingStatesExists(index)">{{ errors[`additional_shippings[${index}].state`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :aria-required="requireStateCityFromCountry(additional_shipping.country_obj?.key)"
                            :id="`shipping_postal_code_${index}`" v-model="additional_shipping.zip_code"
                            :class="{
                                'invalid-state-input': errorsShippingPostalCodesExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`shipping_postal_code_${index}`" :class="{'invalid-state': errorsShippingPostalCodesExists(index)}">
                            <p>Zip/Postal Code {{ requireStateCityFromCountry(additional_shipping.country_obj?.key)? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingPostalCodesExists(index)">{{ errors[`additional_shippings[${index}].zip_code`] }}</p></div>
                </div>
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        v-model="additional_shipping.country_obj"
                        label="Country *"
                        :name="`shipping_country_${index}`" 
                        :id="`shipping_country_${index}`" 
                        aria-label="Enter Shipping Country"
                        :options="formattedCountries"
                        :error="errorsShippingCountriesExists(index)"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsShippingCountriesExists(index)">{{ errors[`additional_shippings[${index}].country`] }}</p></div>
                </div>
                <AddressValidationMessage
                    class="field-state-dealer-app"
                    :street1="additional_shippings[index].address1"
                    :street2="additional_shippings[index].address2"
                    :city="additional_shippings[index].city"
                    :state="additional_shippings[index].state"
                    :postal_code="additional_shippings[index].zip_code"
                    :country="additional_shippings[index].country"
                    @useSuggestedAddress="useSuggestedAdditionalAddress($event,index)"
                />
            </div>
            <div v-if="index == additional_shippings.length-1" class="footer-button-container">
                <RothcoCta id="remove-additional-shipping-address" type="button" @click="removeShipping(index)" class="primary desktop-hidden-flex">Delete</RothcoCta>
                <RothcoCta id="add-additional-shipping-address" type="button" class="secondary" @click="addShipping">Add Additional</RothcoCta>
            </div>
            <div v-else class="footer-button-container">
                <RothcoCta id="remove-additional-shipping-address" type="button" @click="removeShipping(index)" class="primary desktop-hidden-flex">Delete</RothcoCta>
            </div>
        </div>
        <div v-if="!additional_shippings.length" class="footer-button-container">
            <RothcoCta id="add-additional-shipping-address" class="secondary" @click="addShipping">Add Additional</RothcoCta>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, watch } from "vue";
    import RothcoCta from "./RothcoCta.vue";
    import InputText from "primevue/inputtext";
    import CloseIcon from "@icons/closeIcon.svg";
    import AddressValidationMessage from "@/components/AddressValidationMessage.vue";
    let shipping_in_care_of = defineModel("shipping_in_care_of", {type: String, default: ''});
    let shipping_address1 = defineModel("shipping_address1", {type: String, default: ''});
    let shipping_address2 = defineModel("shipping_address2", {type: String, default: ''});
    let shipping_city = defineModel("shipping_city", {type: String, default: ''});
    let shipping_country = defineModel("shipping_country", {type: String, default: ''});
    let shipping_state = defineModel("shipping_state", {type: String, default: ''});
    let shipping_zip_code = defineModel("shipping_zip_code", {type: String, default: ''});
    let additional_shippings = defineModel("additional_shippings", {type: Array<Object>, default: []});
    let sameAsMailingAddress = defineModel("sameAsMailingAddress", {type: Boolean, default: true});
    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });
    let props = defineProps({
        regions: {
            type: String,
            default: ''
        },
        countries: {
            type: Object,
            default(){
                return {};
            }
        },
    });

    let setSameAsMailingAddress = (option) => {
        sameAsMailingAddress.value = option;
        if(sameAsMailingAddress.value == true){
            shipping_in_care_of.value = '';
            shipping_address1.value = '';
            shipping_address2.value = '';
            shipping_city.value = '';
            shipping_country.value = '';
            shipping_state.value = '';
            shipping_zip_code.value = '';
        }
    };

    let formattedCountries = computed(() => {
        return Object.entries(props.countries).map(([key, value]) => {
            return {
                key: key,
                value: value
            };
        });
    });
    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(currentCountry => currentCountry.key == shipping_country.value) ?? {key: '', value: ''};
        },
        set(value){
            shipping_country.value = value.key;
        }
    })
    let availableStates = computed(()=>{
        return JSON.parse(props.regions)[shipping_country.value];
    });
    let getStateEntries = (country) => {
        return Object.entries(JSON.parse(props.regions)[country]).map(([key, value]) => {
            return {
                key: key,
                value: value
            }
        });
    };
    function getAvailableStates(index){
        let state = additional_shippings.value[index].state.toLowerCase();
        switch(additional_shippings.value[index].country){
            case "US":
                return getStateEntries('US');
            case "CA":
                let availableStatesCA = Object.keys(JSON.parse(props.regions).CA);
                for(let key of availableStatesCA){
                    if(JSON.parse(props.regions).CA[key].toLowerCase() == state || key.toLowerCase() == state){
                        additional_shippings.value[index].state = key;
                        break;
                    }
                }
                return getStateEntries('CA');
            case "PR":
                let availableStatesPR = Object.keys(JSON.parse(props.regions).PR);
                for(let key of availableStatesPR){
                    if(JSON.parse(props.regions).PR[key].toLowerCase() == state || key.toLowerCase() == state){
                        additional_shippings.value[index].state = key;
                        break;
                    }
                }
                return getStateEntries('PR');
            default: 
                return null;
        }
    }


    let formattedStates = computed(()=>{
        return Object.entries(availableStates.value)?.map(([key, value]) => {
            return {
                key: key,
                value: value
            }
        });
    });
    let selectedState = computed({
        get(){
            return formattedStates.value.find(currentState => currentState.key == shipping_state.value) ?? {key: '', value: ''};
        },
        set(value){
            shipping_state.value = value.key;
        }
    });
    const requireStateCity = computed(()=>{
        return !!shipping_country.value && ['US','CA'].includes(shipping_country.value);
    })

    function requireStateCityFromCountry(country){
        return !!country && ['US','CA'].includes(country)
    }

    function errorsShippingInCareOfNamesExists(index) {
        return errors.value[`additional_shippings[${index}].in_care_of`];
    }
    function errorsShippingStreets1Exists(index) {
        return errors.value[`additional_shippings[${index}].address1`];
    }
    function errorsShippingStreets2Exists(index) {
        return errors.value[`additional_shippings[${index}].address2`];
    }
    function errorsShippingCitiesExists(index) {
        return errors.value[`additional_shippings[${index}].city`];
    }
    function errorsShippingCountriesExists(index) {
        return errors.value[`additional_shippings[${index}].country`];
    }
    function errorsShippingStatesExists(index) {
        return errors.value[`additional_shippings[${index}].state`];
    }
    function errorsShippingPostalCodesExists(index) {
        return errors.value[`additional_shippings[${index}].zip_code`];
    }
    function addShipping(){
        additional_shippings.value = [...additional_shippings.value, {
            in_care_of: '',
            address1: '',
            address2: '',
            city: '',
            country: 'US',
            state: '',
            zip_code: '',
            country_obj: {key: 'US', value: 'United States'},
            state_obj: {key: '', value: ''}
        }];
    }
    function removeShipping(index){
        let shippings = JSON.parse(JSON.stringify(additional_shippings.value));
        shippings.splice(index, 1);
        additional_shippings.value = shippings;
    }

    watch(() => additional_shippings.value, (newVal, oldVal) => {
        const updatedShippings = newVal.map((val, index) => {
            let availableStates = getAvailableStates(index);
            let newCountryValue = val.country_obj.key;
            let oldCountryValue = oldVal[index]?.country;
            let temp_state_obj;
            if (availableStates) {
                for (let s of availableStates) {
                    if (s.key.toLowerCase() === val.state.toLowerCase() || s.value.toLowerCase() === val.state.toLowerCase()) {
                        temp_state_obj = s;
                        break;
                    }
                }
                if (!['US', 'CA', 'PR'].includes(newCountryValue) && ['US', 'CA', 'PR'].includes(oldCountryValue)) {
                    return {
                        ...val,
                        country: newCountryValue,
                        state: '',
                        state_obj: { key: '', value: '' }
                    };
                }
                if (['US', 'CA', 'PR'].includes(newCountryValue)) {
                    if (val.state) {

                        if (!temp_state_obj) {
                            return {
                                ...val,
                                country: newCountryValue,
                                state: '',
                                state_obj: { key: '', value: '' }
                            };
                        }
                    }
                }
                if(temp_state_obj?.key !== val.state_obj?.key && val.state_obj.key) {
                    return {
                        ...val,
                        country: newCountryValue,
                        state: val.state_obj.key,
                        state_obj: val.state_obj
                    };
                }
                return {
                    ...val,
                    country: newCountryValue,
                    state: temp_state_obj?.key ?? val.state_obj.key,
                    state_obj: temp_state_obj ?? val.state_obj
                };
            } else {
                return {
                    ...val,
                    country: newCountryValue,
                    state_obj: { key: '', value: '' }
                };
            }
        });
        if (JSON.stringify(updatedShippings) !== JSON.stringify(oldVal)) {
            additional_shippings.value = updatedShippings;
        }
    }, { deep: true });

    watch(shipping_country, (newCountryValue, oldCountryValue) => {
        if (!['US', 'CA', 'PR'].includes(newCountryValue) && ['US', 'CA', 'PR'].includes(oldCountryValue)) {
            shipping_state.value = '';
            return;
        }
        if (['US', 'CA', 'PR'].includes(newCountryValue)) {
            let state = shipping_state.value.toLowerCase();
            let availableStateKeys = Object.keys(availableStates.value || {});

            let matchedState = availableStateKeys.find(
                key => availableStates.value[key].toLowerCase() === state || key.toLowerCase() === state
            );
            shipping_state.value = matchedState ?? '';
        }
    });

    const useSuggestedShippingAddress = (suggestedAddress)=>{
        shipping_address1.value = suggestedAddress.street1;
        shipping_address2.value = suggestedAddress.street2;
        shipping_city.value = suggestedAddress.city;
        shipping_state.value = suggestedAddress.state;
        shipping_zip_code.value = suggestedAddress.postal_code;
        shipping_country.value = suggestedAddress.country == 'USA' ? 'US' : suggestedAddress.country;
    }

    const useSuggestedAdditionalAddress = (suggestedAddress, index)=>{
        additional_shippings.value[index].address1 = suggestedAddress.street1;
        additional_shippings.value[index].address2  = suggestedAddress.street2;
        additional_shippings.value[index].city = suggestedAddress.city;
        additional_shippings.value[index].state = suggestedAddress.state
        additional_shippings.value[index].zip_code = suggestedAddress.postal_code
        additional_shippings.value[index].country = suggestedAddress.country == 'USA' ? 'US' : suggestedAddress.country;
    }

</script>
<style scoped lang="scss">
.footer-button-container {
    display: flex; 
    justify-content: center; 
    padding: 1.25rem; 
    gap: 1.25rem;
}
</style>